module.exports = __webpack_public_path__ + "img/HSLogo.e8f3681f.png";